import { useMemo } from 'react'
import { useSearchParams } from 'react-router'
import { toast } from 'sonner'
import { apiErrorMessage } from '@/i18n'
import { useProjects, useStaff } from './api'
import type { StaffUser } from './types'

export function toastError(e: unknown) {
  toast.error(apiErrorMessage(e))
}

/** Seçili proje URL'de (`?p=`) tutulur; yoksa listedeki ilk proje. */
export function useSelectedProjectId() {
  const projects = useProjects()
  const [params, setParams] = useSearchParams()
  const requested = params.get('p')
  const list = projects.data ?? []
  const id = list.find((p) => p.id === requested)?.id ?? list[0]?.id ?? null
  const select = (next: string | null) =>
    setParams(
      (prev) => {
        const out = new URLSearchParams(prev)
        if (next) out.set('p', next)
        else out.delete('p')
        return out
      },
      { replace: true },
    )
  return { projects, selectedId: id, select }
}

export function useStaffLookup() {
  const staff = useStaff()
  return useMemo(() => {
    const byId = new Map<string, StaffUser>((staff.data ?? []).map((u) => [u.id, u]))
    return { staff: staff.data ?? [], byId, nameOf: (id: string | null) => (id ? (byId.get(id)?.name ?? '—') : '—') }
  }, [staff.data])
}
